import { render } from "./QuestionnaireIOS.vue?vue&type=template&id=e22afbc0&scoped=true&ts=true"
import script from "./QuestionnaireIOS.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireIOS.vue?vue&type=script&lang=ts"

import "./QuestionnaireIOS.vue?vue&type=style&index=0&id=e22afbc0&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e22afbc0"]])

export default __exports__